import { render, staticRenderFns } from "./DatenschutzPage.vue?vue&type=template&id=20081192&scoped=true&"
import script from "./DatenschutzPage.vue?vue&type=script&lang=js&"
export * from "./DatenschutzPage.vue?vue&type=script&lang=js&"
import style0 from "./DatenschutzPage.vue?vue&type=style&index=0&id=20081192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20081192",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VBtn,VContainer,VMain})
